import { Tool, ToolType } from './Tool'
import { Modify, Select } from 'ol/interaction'
import Feature, { FeatureLike } from 'ol/Feature'
import Geometry from 'ol/geom/Geometry'

export default class ModifyTool extends Tool {
    private selectInteraction!: Select;
    private modifyInteraction!: Modify;

    public removeInteractions(): void {
        if (this.selectInteraction) { this.state.map?.removeInteraction(this.selectInteraction) }
        if (this.modifyInteraction) { this.state.map?.removeInteraction(this.modifyInteraction) }
    }

    public addInteractions(): void {
        this.selectInteraction = new Select({
            multi: false,
            filter: (feature) => feature.get('type') !== ToolType.MEASURING
        })

        this.modifyInteraction = new Modify({
            features: this.selectInteraction.getFeatures()
        })

        this.state.map!.addInteraction(this.selectInteraction)
        this.state.map!.addInteraction(this.modifyInteraction)

        this.modifyInteraction.on('modifystart', (evt) => {
            evt.features.forEach((feature) => {
                this.tooltipManager.removeToolTip(feature)
            })
        })
        this.modifyInteraction.on('modifyend', (evt) => {
            evt.features.forEach((feature:FeatureLike) => {
                this.annotationManager.recalculateAreaAndDistance(feature as Feature<Geometry>)
                let showTitle = feature.get('showTitle')
                let showArea = feature.get('showArea')
                if (showTitle || showArea) {
                    this.tooltipManager.createFixedToolTip(feature as Feature<Geometry>)
                }
                this.annotationManager.notifyChangesMade()
            })
        })
    }
}
